// icons/other.svg
export const OtherIconV2 = (props) => (
  <svg
    className={props.className}
    width="18"
    height="4"
    viewBox="0 0 18 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="2" cy="2" r="2" fill="#34363E" />
    <circle cx="9" cy="2" r="2" fill="#34363E" />
    <circle cx="16" cy="2" r="2" fill="#34363E" />
  </svg>
);
